import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/app/environments/environment';
import { ChartDetails, ExcelDataModel, fomData, UserIdentityDocument, ChatHistoryDocument, ChatListDocument, ChatAnswerDocument, ChatHistoryResponse, SaveChatResponseRequest, SaveChatFeedbackRequest } from '../models/chatbotexpand.model';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  getChatBotInsightsData(
    insightsData: any, selectedstudy: string, selectedclient: string, isTotalBase: string): Observable<string> {
    const body = {
      data: JSON.stringify(insightsData),
      study: selectedstudy,
      client: selectedclient,
      isTotalBase: isTotalBase
    };
    return this.http.post(
      `${this.apiBaseUrl}api/ChatBot/getChatBotGptRepsonse`,
      body,
      { responseType: 'text' }
    );
  }

  getInsightsData(
    isIndexSelected: any,
    insightsData: any,
    selectedstudy: string,
    selectedclient: string,
    selectionSummary: string,
    confidenceLevel: string,
    ShareColumn: string = '',
    BaseColumn: string = '',
    brand_name: string = '',
    funnelChartSelectedItem: string = '',
    widgetName: string = '',
    WidgetId: string = '',
  ): Observable<string> {

    const formData = new FormData();
    formData.append('isIndexSelected', isIndexSelected);
    formData.append('data', JSON.stringify(insightsData));
    formData.append('study', selectedstudy);
    formData.append('client', selectedclient);
    formData.append('selectionSummary', selectionSummary);
    formData.append('confidenceLevel', confidenceLevel);
    formData.append('shareColumn', ShareColumn);
    formData.append('baseColumn', BaseColumn);
    formData.append('brand_name', brand_name);
    formData.append('widget_name', widgetName);
    formData.append('widget_Id', WidgetId);
    formData.append('funnelChartSelectedItem', funnelChartSelectedItem);
    return this.http.post(
      `${this.apiBaseUrl}api/Snapshot/getSnapshotInsights`,
      formData,
      { responseType: 'text' }
    );

  }


  apiBaseUrl = environment.baseApiUrl;
  constructor(private http: HttpClient) { }
  private variableTabDataSubject = new BehaviorSubject<any>('');
  variableTabData$ = this.variableTabDataSubject.asObservable();

  exportToPPT(data: ChartDetails): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/pptARKExport`;
    return this.http.post(exportUrl, data, { responseType: 'blob' });
  }
  getDiagonistics1(request: any): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetDiagonistics';
    return (this.http
      .post<any>(
        `${this.apiBaseUrl}api/ChatBot/GetDiagonistics`,
        request,
      )
    );
  }
  exportToExcelARK(data: ExcelDataModel): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/excelExportARK`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  exportToExcelARKSnapshot(data: any): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/excelExportARKSnapshot`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  callPptExportSnapshot(imgString: string, data: any, isTredendDataRequired: boolean = false): Observable<Blob> {
    const url = `${this.apiBaseUrl}api/ChatBot/pptExportSnapshot`;
    let formData = new FormData();
    data.imgString = imgString;
    data.isTredendDataRequired = isTredendDataRequired;
    formData.append("inputObj", JSON.stringify(data));
    return this.http.post(url, formData, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  exportToExcelSnapshot(data: any): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/pptExportSnapshot`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  getOutputData(
    inputQuery: string,
    selectedclient: string,
    selectedstudy: string,
    aggregatedVariables: any = [],
    formattedJSON: any,
    weightFilter?: Record<string, string>
  ): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetQuery';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      input_Query: inputQuery,
      selectedclient: selectedclient,
      selectedstudy: selectedstudy,
      aggregatedVariables: aggregatedVariables,
      formattedJSON: formattedJSON,
      ...(weightFilter ? { weightFilter: weightFilter } : {})
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  getDiagonistics(): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetDiagonistics';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      request: "inputQuery"
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  downloadDiagnosticsExcel(): Observable<Blob> {
    return this.http.post(`${this.apiBaseUrl}api/ChatBot/DownloadDiagnosticsExcel`, {}, {
      responseType: 'blob'
    });
  }

  getMcode(
    inputQuery: string,
    client_name: string,
    selectedStudy: string,
    chat_id: string

  ): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetMcode';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      input_Query: inputQuery,
      selectedClient: client_name,
      selectedStudy: selectedStudy,
      chat_id: chat_id
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  getChatList(): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetChatList';
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetChat error:', error);
        return throwError(() => error);
      })
    );
  }

  saveChatList(title: string, chatId?: string): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/SaveChatList';
    const body = {
      ChatTitle: title,
      ChatId: chatId || ''
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChat error:', error);
        return throwError(error);
      })
    );
  }

  saveChatHistory(request: SaveChatResponseRequest): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/SaveChatResponse';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(url, request, { headers, responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChatHistory error:', error);
        return throwError(() => error);
      })
    );
  }

  getChatResponse(messageId: string): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetChatResponse?messageId=' + encodeURIComponent(messageId);

    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetChatResponse error:', error);
        return throwError(() => error);
      })
    );
  }

  getLoadData(value: any): Observable<any> {
    const path = 'api/DataExplorer/getLoadData';
    return this.http.post<any>(this.apiBaseUrl + path, value).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(() => error);
      })
    );
  }

  getLoadDataBrandAnalysis(value: any): Observable<any> {
    const path = 'api/DataExplorer/getLoadDataBrandAnalysis';
    return this.http.post<any>(this.apiBaseUrl + path, value).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(() => error);
      })
    );
  }

  getUserIdentity(userId: string): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/GetUserIdentity?userId=${encodeURIComponent(userId)}`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetUserIdentity error:', error);
        return throwError(() => error);
      })
    );
  }

  saveUserIdentity(doc: UserIdentityDocument): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/SaveUserIdentity`;
    return this.http.post(url, doc, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveUserIdentity error:', error);
        return throwError(() => error);
      })
    );
  }

  updateChatStarred(messageId: string, isStarred: boolean): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/UpdateChatStarred`;
    const body = {
      MessageId: messageId,
      IsStarred: isStarred
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('UpdateChatStarred error:', error);
        return throwError(() => error);
      })
    );
  }

  getStarredMessages(): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/GetStarredMessages`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetStarredMessages error:', error);
        return throwError(() => error);
      })
    );
  }

  saveChatFeedback(feedback: { MessageId: string; IsLiked: boolean | null; DislikeReason?: string }): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/SaveChatFeedback`;
    return this.http.post(url, feedback, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChatFeedback error:', error);
        return throwError(() => error);
      })
    );
  }

  deleteChatMessage(messageId: string): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/DeleteChatMessage`;
    const body = {
      MessageId: messageId
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('DeleteChatMessage error:', error);
        return throwError(() => error);
      })
    );
  }

}
